module.exports = __webpack_public_path__ + "public/SiteIcons/documentUpload.svg?d3ccc8d5";